import { Error as ErrorIcon } from '@cheqroom/icons';
import { FC, ReactNode } from 'react';
import { theme } from 'twin.macro';

import type { Error } from '../../../@types/index.d';
import { Icon } from '../Icon/Icon';
import { StyledLabel } from '../Labelled/Labelled.styles';
import { Stack } from '../Stack/Stack';
import { Text } from '../Typography/Text/Text';
import { StyledChoice } from './Choice.styles';

export interface ChoiceProps {
	/** Whether the associated form control is disabled */
	disabled?: boolean;
	/** Display an error message */
	error?: Error | boolean;
	/** Additional text to aide in use */
	helpText?: ReactNode;
	/** A unique identifier for the choice */
	id?: string;
	/**	Label for the choice */
	label: ReactNode;
	/** Visually hide the label */
	labelHidden?: boolean;
	children: ReactNode;
}

export const Choice: FC<ChoiceProps> = ({ children, disabled, error, helpText, id, label, labelHidden }) => (
	<StyledChoice
		spacing={labelHidden && !helpText && !error ? 'none' : 'tight'}
		align={helpText || error ? 'start' : 'center'}
		disabled={disabled}
	>
		<div tw="flex h-5 items-center justify-center">{children}</div>
		<Stack vertical spacing="extraTight" tw="overflow-hidden">
			<StyledLabel as="label" htmlFor={id} labelHidden={labelHidden}>
				{label}
			</StyledLabel>

			{helpText && (
				<Text color="subdued" size="small">
					{helpText}
				</Text>
			)}
			{error && typeof error !== 'boolean' && (
				<Stack align="center" spacing="extraTight">
					<Icon source={ErrorIcon} color={theme`colors.red.700`} size="small" />
					<Text color="red" size="small">
						{error}
					</Text>
				</Stack>
			)}
		</Stack>
	</StyledChoice>
);
